import React, { useState } from 'react';
import {
  Box,
  Button
} from '@material-ui/core';

import CustomerDetails from 'components/Customers/CustomerDetails';
import CustomersTable from 'components/Customers/CustomersTable';

import { standard } from 'constants/userAccountTypes';

const CustomerListResults = (props) => {

  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});

  const addCustomer = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateCustomer = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
  };

  const createCustomerDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.user.adminId).body.customer;
    let customerNum;
    length < 100 ? 
      customerNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : customerNum = length
    return ("C-" + customerNum);
  };

  return (
    <Box>
      { open ?
        ( update ?
          <CustomerDetails
            update={update}
            cancelAddUpdate={cancelAddUpdate}
            customerInfo={updateInfo}
          /> :
          <CustomerDetails
            user={props.user}
            update={update}
            cancelAddUpdate={cancelAddUpdate}
            customerInfo={{
              displayId: createCustomerDisplayId(),
              name: "",
              phone: "",
              addressLine: "Sharjah",
              city: "sharjah",
              country: "UAE",
              trn: ""
            }}
          />
        ) :
        <Box>
          { props.activeUserType === standard ?
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            > 
              <Button
                color="primary"
                variant="contained"
                onClick={addCustomer}
              >
                Add Customer
              </Button>
            </Box>
          : null }
          <Box marginTop={2}>
            <CustomersTable
              activeUserType={props.activeUserType}
              customers={props.customers}
              updateCustomer={updateCustomer}
              setUpdateInfo={setUpdateInfo}
            />
          </Box>
        </Box>
      }
    </Box>
  )
};

export default CustomerListResults;
